var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderFrontGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 161,
    viewBox: "0 0 194 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4355 -0.705078L11.6816 14.5488C11.827 23.5632 19.1759 30.7949 28.1914 30.7949H165.043C174.129 30.7949 181.508 23.4535 181.555 14.3672L181.632 -0.705078H192.811V150.952C192.811 155.301 189.285 158.827 184.936 158.827H8.12891C3.77972 158.827 0.253906 155.301 0.253906 150.952V-0.705078H11.4355Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4355 -0.705078L11.6816 14.5488C11.827 23.5632 19.1759 30.7949 28.1914 30.7949H165.043C174.129 30.7949 181.508 23.4535 181.555 14.3672L181.632 -0.705078H192.811V150.952C192.811 155.301 189.285 158.827 184.936 158.827H8.12891C3.77972 158.827 0.253906 155.301 0.253906 150.952V-0.705078H11.4355Z",
    fill: "url(#paint0_linear_2518_3090)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4355 -0.705078L11.6816 14.5488C11.827 23.5632 19.1759 30.7949 28.1914 30.7949H165.043C174.129 30.7949 181.508 23.4535 181.555 14.3672L181.632 -0.705078H192.811V150.952C192.811 155.301 189.285 158.827 184.936 158.827H8.12891C3.77972 158.827 0.253906 155.301 0.253906 150.952V-0.705078H11.4355Z",
    stroke: "white",
    strokeWidth: 0.508065
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2518_3090",
    x1: 96.5323,
    y1: -0.958984,
    x2: 96.5323,
    y2: 159.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AD56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608402,
    stopColor: "#507434",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#507434"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderFrontGreen);
export default __webpack_public_path__ + "static/media/folder-front-green.484414cd84a22064e8777e6a2715ad83.svg";
export { ForwardRef as ReactComponent };